/* eslint-disable
  @typescript-eslint/no-use-before-define,
  @typescript-eslint/no-explicit-any,
  @typescript-eslint/explicit-module-boundary-types
*/
import { Component, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HourlyPoolSchedule, HourlyPoolScheduleItem } from 'api/types';
import { calculateTimeSlots, calculateTimeSlotsMinute, calculateTimeSlotsMinuteWise, duplicatecalculateTimeSlots } from 'components/common/pools/utils/calculate-time-slots';
import { getPoolStartEndTime } from 'components/common/pools/utils/get-pool-start-end-time';
import { UTC_TIMES } from 'data/utc-times';
import { AddUTCToTimePipe } from 'pipes/add-utc-to-time.pipe';
import { SuppressErrorMatcher } from 'utils/error-matchers/suppress.error-matcher';
import { removeUTCTimes } from 'utils/time-utils';
import { AddPoolState } from '../add-pool-state/add-pool-state.service';
import { MatRadioChange } from '@angular/material/radio';


export interface TimeSlot {
  startTime: string;
  endTime: string;
  capacity: number;
}
/**
 *  Form controls for setting pool schedule
 */
@Component({
    selector: 'app-pool-schedule',
    templateUrl: './pool-schedule.component.html',
    styleUrls: ['./pool-schedule.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR, useExisting: PoolScheduleComponent, multi: true
        }],
    standalone: false
})



export class PoolScheduleComponent implements ControlValueAccessor, OnDestroy {

  @Input() showOpenButton:any;

  private minuteCapacityItems:any= ''
private hourlyCapacityItems:any='';

private hourlyEditedSlots = new Set<string>();

  public suppressErrorState = new SuppressErrorMatcher();
  public utcStartTimes = [ ...UTC_TIMES ];
  public utcEndTimes = [ ...UTC_TIMES ];

  public capacityItems: HourlyPoolScheduleItem[] = [];
  public scheduleForm: UntypedFormGroup;
  public selectedOptions :any="Hourly"

  // Form functions
  private onChangeCallback: (_: any) => void = noop;
  private onTouchedCallback = noop;

  private destroyed = new Subject();

  public constructor(
    private formBuilder: UntypedFormBuilder,
    private addPoolState: AddPoolState,
    private addUTCToTimePipe: AddUTCToTimePipe
  ) {
    // Build internal form
    // this.scheduleForm = formBuilder.group({
    //   startTime: new UntypedFormControl(''),
    //   endTime: new UntypedFormControl(''),
    //   items: formBuilder.array([])
    // });

  this.scheduleForm = formBuilder.group({
  startTime: new UntypedFormControl(''),
  endTime: new UntypedFormControl(''),
  hourlyItems: formBuilder.array([]),
  minuteItems: formBuilder.array([])
});
    // Subscribe to changes in hourly capacity to calculate total
    this.scheduleForm.controls.hourlyItems.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe((items) => {
        this.addPoolState.totalCapacity = (items as number[]).reduce((total, curr) => {
          return total + (curr || 0);
        }, 0);
        this.minuteCapacityItems = this.addPoolState.totalCapacity
        this.updateParentForm();
      });

     this.scheduleForm.controls.minuteItems.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe((items) => {
        this.addPoolState.mintotalCapacity = (items as number[]).reduce((total, curr) => {
          return total + (curr || 0);
        }, 0);
     this.hourlyCapacityItems=this.addPoolState.mintotalCapacity
        this.updateParentForm();
      });

    // Restrict end time based on start time
    this.scheduleForm.controls.startTime.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe((value) => {
        this.utcEndTimes = removeUTCTimes(value, 'before');
        this.updateTimeSlots();
      });

    // Restrict start time based on end time
    this.scheduleForm.controls.endTime.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe((value) => {
        this.utcStartTimes = removeUTCTimes(value, 'after');

        this.updateTimeSlots();
      });
  }

  // Terminate subscriptions
  public ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  public get hourlyItems(): UntypedFormArray {
    return this.scheduleForm.controls.hourlyItems as UntypedFormArray;
  }

  public get totalCapacity(): number {
    return this.addPoolState.totalCapacity;
  }

  
  public get totalCapacityformin(): number {
    return this.addPoolState.mintotalCapacity;
  }

  // Replace old form array with a new one
  public setCapacityFormItems(scheduleItems: HourlyPoolScheduleItem[]): void {
    const { hourlyItems } = this.scheduleForm.controls;
    (hourlyItems as UntypedFormArray).clear({ emitEvent: false });
    scheduleItems.forEach((scheduleItem) => {
      (hourlyItems as UntypedFormArray).push(
        this.formBuilder.control(scheduleItem.capacity),
        { emitEvent: false }
      );
    });

    hourlyItems.updateValueAndValidity();
  }

   public setCapacityFormItemsformin(scheduleItems: HourlyPoolScheduleItem[]): void {
    const { minuteItems } = this.scheduleForm.controls;
    (minuteItems as UntypedFormArray).clear({ emitEvent: false });
    scheduleItems.forEach((scheduleItem) => {
      (minuteItems as UntypedFormArray).push(
        this.formBuilder.control(scheduleItem.capacity),
        { emitEvent: false }
      );
    });

    minuteItems.updateValueAndValidity();
  }

  // Get control of item that tracks capacity
  public getItemControl(index: number): UntypedFormControl {
    return (this.scheduleForm.controls.hourlyItems as UntypedFormArray).at(index) as UntypedFormControl;
  }

   public getItemControlmin(index: number): UntypedFormControl {
    return (this.scheduleForm.controls.minuteItems as UntypedFormArray).at(index) as UntypedFormControl;
  }

  // Handle form change
  public updateParentForm(): void {
    const newSchedule = this.buildSchedule();
    this.onTouchedCallback();
    this.onChangeCallback(newSchedule);
  }

  // Update local form from parent
  public writeValue(initialValue: any): void {
   
    
    if (Array.isArray(initialValue.hourlyItems) && initialValue.hourlyItems.length) {
      const { startTime, endTime } = this.scheduleForm.controls;
      const { poolStartTime, poolEndTime } = getPoolStartEndTime(initialValue.hourlyItems);
      startTime.setValue(poolStartTime);
      endTime.setValue(poolEndTime);
      this.setCapacityFormItems(initialValue.hourlyItems);
      this.capacityItems =initialValue.hourlyItems;
      this.updateTimeSlots();
    }
  }

  /**
   * Update parent form control has been change
   *
   * @param fn function from parent
   */
  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  /**
   * Update parent form control has been touched
   *
   * @param fn function from parent
   */
  public registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  /**
   * @param time time
   * @returns time with (UTC) added
   */
  public addUTCToTime(time: string): string {
    return this.addUTCToTimePipe.transform(time);
  }

  // Builds hourly schedule object
  private buildSchedule(): HourlyPoolSchedule {
 
    
    return {
      type: 'hourly',
      items: this.capacityItems.map((item, index) => {
        return {
          startTime: item.startTime,
          endTime: item.endTime,
          capacity: this.getItemControl(index)?.value || 0
        };
      })
    };
  }

  // Recalculate time slots and update form controls
  private updateTimeSlots(): void {
    const { startTime, endTime, hourlyItems,minuteItems } = this.scheduleForm.controls;
if (this.showOpenButton == false){
   const timeSlotsWithCapacity = this.capacityItems.map((item, index) => {
      return {
        ...item,
        capacity: item.capacity
      };
    });

    const timeSlots = duplicatecalculateTimeSlots(startTime.value, endTime.value, timeSlotsWithCapacity);
    this.setCapacityFormItems(timeSlots);
    this.capacityItems = timeSlots;
}
else{

    if(this.selectedOptions == 'Hourly'){

      const timeSlotsWithCapacity = this.capacityItems.map((item, index) => {
   
      
      return {
        ...item, 
        capacity: minuteItems.value[ index ] || 0
      };
    });
      

      
const timeSlots = calculateTimeSlots(startTime.value, endTime.value, timeSlotsWithCapacity);
   
    this.setCapacityFormItems(timeSlots);
    this.capacityItems = timeSlots;
      
      
     
    }else if(this.selectedOptions == 'Minutes'){

      const timeSlotsWithCapacity = this.capacityItems.map((item, index) => {
    
      return {
        ...item,
        capacity: hourlyItems.value[ index ] || 0
      };
    });
   
      
      if(this.minuteCapacityItems == this.hourlyCapacityItems || (this.minuteCapacityItems == '' || this.hourlyCapacityItems == '')){
        const timeSlots = calculateTimeSlotsMinute(startTime.value, endTime.value, timeSlotsWithCapacity);
    
       
    this.setCapacityFormItemsformin(timeSlots);
    this.capacityItems = timeSlots;
      }
      
  
    
    }
   
}
   
    this.updateParentForm();
  }


  

  selectedOption(event:any){
 
  this.selectedOptions=event.value
  this.updateTimeSlots();


  
  }

//   selectedOption(event: MatRadioChange): void {
//   const nextMode = event.value as 'Hourly' | 'Minutes';
//    const { startTime, endTime, items } = this.scheduleForm.controls;

//    const timeSlotsWithCapacity = this.capacityItems.map((item, index) => {
    
//       return {
//         ...item,
//         capacity: items.value[ index ] || 0
//       };
//     });

//   if (nextMode === this.selectedOptions) {
//     return;
//   }

//   // Save the current mode before switching.
//   const currentItems = this.saveCurrentCapacityItems();

//   if (this.selectedOptions === 'Minutes') {
//     this.minuteCapacityItems = currentItems;
//   } else {
//     this.hourlyCapacityItems = currentItems;
//   }

//   this.selectedOptions = nextMode;

//   if (nextMode === 'Hourly') {
//     this.hourlyCapacityItems = calculateTimeSlots(
//       startTime.value, endTime.value, timeSlotsWithCapacity
//     );

//     // Apne existing helper se FormArray populate karo.
//     this.updateCapacityForm(this.hourlyCapacityItems);
//   } else {
//     this.hourlyCapacityItems =
//       this.hourlyCapacityItems.length > 0
//         ? this.hourlyCapacityItems
//         : calculateTimeSlots(
//             startTime.value, endTime.value, timeSlotsWithCapacity
//           );

//     const minuteItems = calculateTimeSlotsMinute(
//       startTime.value, endTime.value,
//       timeSlotsWithCapacity
     
//     );

//     this.minuteCapacityItems = minuteItems;

//     this.updateCapacityForm(minuteItems);

//     // Reset only after the minute values have been generated.
//     this.hourlyEditedSlots.clear();
//   }
// }

  private saveCurrentCapacityItems(): TimeSlot[] {
  return this.capacityItems.map((item, index) => ({
    ...item,
    capacity: Number(this.getItemControl(index).value ?? 0),
  }));
}
}
